import ErrorResponseObject from '../../interfaces/errorResponseObject';

function getErrorMessage(errorResponse: ErrorResponseObject): string {
  if (
    errorResponse?.code === 'ERR_BAD_REQUEST' &&
    errorResponse?.response?.status === 400
  ) {
    if (errorResponse.response.data) {
      const firstErrorKey = Object.keys(errorResponse.response.data)[0];
      if (Array.isArray(errorResponse.response.data[firstErrorKey])) {
        const firstErrorMessage = errorResponse.response.data[firstErrorKey][0];
        return firstErrorMessage;
      }
    }
  }
  return 'An unknown error occurred';
}

export default getErrorMessage;